import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import {ModelTagsMixin} from "./mixins/ModelTagsMixin.jsx";
import {getAging} from "../../other/utils/utils.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";
import {getEntityNames} from "../../other/utils/otherUtils.jsx";

export class Contact extends ModelTagsMixin(HasProjectMixin(Model)) {
  static get $name() {
    return "Contact";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "phone", dataSource: "phone" },
      { name: "email", dataSource: "email" },
      { name: "address", dataSource: "address" },
      { name: "noteText", dataSource: "notes_text" },
      { name: "createdAt", dataSource: "created_at" },
      { name: "lastUpdatedAt", dataSource: "updated_at" },
      { name: "lastUpdatedBy", dataSource: "updated_by" },
      { name: "entities", persist: false, defaultValue: [] },
      { name: "entitiesValue", persist: false, defaultValue: [] },
      { name: "aging", persist: false },
      { name: "updateRendererCount", persist: false, defaultValue: 0 }
    ];
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get contactDetail() {
    const contactRecord = this;
    if (contactRecord) {
      return [contactRecord];
    }
    return [];
  }

  get tagStoreName() {
    return STORE_KEYS.contactTagValuesStore;
  }

  // Todo: Needs to be triggered again if any of the entity contact has been archived
  get entities() {
    // for group renderer, the entityContacts returns undefined
    const taskContactsEntityNames = getEntityNames(this.taskContacts, STORE_KEYS.taskStore);
    const resourceContactsEntityNames = getEntityNames(this.resourceContacts, STORE_KEYS.resourceStore);
    const clientContactsEntityNames = getEntityNames(this.clientContacts, STORE_KEYS.clientStore);
    const userContactsEntityNames = getEntityNames(this.userContacts, STORE_KEYS.boardUserStore);
    return [
      ...userContactsEntityNames,
      ...taskContactsEntityNames,
      ...resourceContactsEntityNames,
      ...clientContactsEntityNames
    ];
  }

  get entitiesValue() {
    return this.entities.map((entity) => entity.name);
  }
}

Contact.exposeProperties();
